module.exports = __webpack_public_path__ + "static/img/11a.c154216.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/11a.jpg
// module id = ASPg
// module chunks = 1